export enum CreditUnionRole {
    CREDIT_UNION_ADMIN = 'Admin',
    CREDIT_UNION_USER = 'User'
}